import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { handleKeySubmit } from '../../utilities/userUtil';

const padNumber = (number, total) => {
  const columns = (total + '').length;
  const zeros = new Array(columns).join('0');
  return (zeros + number).slice(-columns)
}

export default class ProgressBar extends Component {
  static propTypes = {
    step: PropTypes.number,
    total: PropTypes.number.isRequired,
    title: PropTypes.string,
    onBack: PropTypes.func.isRequired,
    onFinishLater: PropTypes.func,
  }

  static defaultProps = {
    step: 0,
    title: null,
    onFinishLater: null
  }

  constructor(props) {
    super(props);
    this.state = {
      step: props.step
    }
  }

  // Manage step in local state to account for fade animations so step doesnt drop back down to 0 between animations
  componentDidUpdate(prevProps) {
    if (this.props.step !== null && prevProps.step !== this.props.step) {
      this.setState({ step: this.props.step });
    }
  }

  render() {
    const { onBack, onFinishLater, total, title } = this.props;
    const { step } = this.state;
    const percent = Math.floor((step) / total * 100)

    return (
      <div className="progress">
        <div className="progress__bar">
          <div className="progress__filled" style={{ width: `${percent}%` }} />
        </div>
        <div className="progress__sub">
          <div
            className="type__link__primary progress__back"
            onClick={onBack}
            onKeyDown={(event) => handleKeySubmit(event.keyCode, onBack)}
            tabIndex="0"

          >
            {'< Back'}
          </div>
          <div className="progress__info">
            <span className="type__label">{`Section ${padNumber(step, total)} of ${total}`}</span>
            {title && (<span>{title}</span>)}
          </div>
          <div
            className={`progress__finish ${!onFinishLater ? 'progress__finish--hidden' : ''}`}
            onClick={onFinishLater}
            onKeyDown={(event) => handleKeySubmit(event.keyCode, onFinishLater)}
            tabIndex="0"
          >
            {'Finish Later'}
          </div>
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.js